// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable jsx-a11y/label-has-for, multiline-comment-style */
import React from "react"
import classnames from "classnames"

import RadioButtonsRadio from "./RadioButtonsRadio"
import type { RadioButtonMode } from "./RadioButtons.types"

type Props = {
  mode: RadioButtonMode
  handleChange: (arg1: string) => void
  active?: string
  forcedValue?: string
}

const RadioButtonsOption = ({
  mode: { value, disabled, customClass = "", icon, label, cssClass = "", customLabel, element },
  active,
  handleChange,
  forcedValue,
}: Props) => (
  <label
    className={classnames("RadioButtonsOption", {
      _checked: value === active,
      _disabled: disabled,
      /* $FlowFixMe This comment suppresses an error found when upgrading Flow
       * to v0.118.0. To view the error, delete this comment and run Flow. */
      [customClass]: customClass,
    })}
  >
    <RadioButtonsRadio
      checked={value === active || forcedValue === active}
      onChange={() => {
        // Fix this the next time the file is edited. (Flow to TS)
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        handleChange(forcedValue || value)
      }}
      // Fix this the next time the file is edited. (Flow to TS)
      // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
      value={forcedValue || value}
      disabled={disabled}
    />
    {icon && <i className={`RadioButtonsOption-icon ${icon}`} />}
    {label && <div className={`RadioButtonsOption-label spTypo-bold ${cssClass}`}>{label}</div>}
    {/* TODO: this is really stupid check, but it's a beta ¯\_(ツ)_/¯ */}
    {label === "Nomad" && <sub className="RadioButtonsOption-label-sub">BETA</sub>}
    {customLabel && <div className="RadioButtonsOption-customLabel">{customLabel}</div>}
    {element}
  </label>
)

export default RadioButtonsOption
